import './z_header';
import '../css/z_category.less';
import pagination from '../../libs/pagination/pagination';
import listImg from '../../libs/list_img/list_img';
import banner from '../../libs/banner/banner';
import '../css/list_img.less';

// banner
if($('body').width()<768){
    banner.render({ bannerScale: 4/3 });
}else{
    banner.render({ bannerWidth: 1920, bannerHeight: 650 });
}

pagination.render({
    limit: 12,
});
listImg.render();